export default __webpack_public_path__ + "static/media/collection_box.14e1b0b7.png";